"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pick = void 0;
function pick(obj, keys) {
    var out = {};
    keys.forEach(function (key) { return out[key] = obj[key]; });
    return out;
}
exports.pick = pick;
//# sourceMappingURL=pick.js.map